module.exports = "/_next/static/images/CollectDataTabs-2@2x-2c6453b36d624b8a60c2064dfabf401f.webp";